import { DesignApi, Configuration } from '@/rest'
import { PaintingByNumbersModule } from '@/store/modules/paintingByNumbers';
import { AppModule } from '@/store/modules/app';

export default function getDesigns(categoryId: any, pieceCount: string, orientation: string, boxType: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        let designApi = new DesignApi(
            new Configuration({ basePath: '/rest'})
        )
        let sessionId = ""
        if(AppModule.session && AppModule.session.sessionId) {
            sessionId = AppModule.session.sessionId
        }
        let getDesignsRequest = {"categoryId":categoryId, "pieceCount":pieceCount, "orientation":orientation, "boxType":boxType, "sessionId" : sessionId};
        designApi.getDesigns(getDesignsRequest).then(
            (value) => {
                PaintingByNumbersModule.SET_AVAILABLE_DESIGNS(value)
                resolve()
            },
            (reason) => {
                window.console.log(reason)
                reject()
            });
    });
}